import { render, staticRenderFns } from "./AcompanhamentoForm.vue?vue&type=template&id=3d2b06fc&scoped=true&"
import script from "./AcompanhamentoForm.vue?vue&type=script&lang=js&"
export * from "./AcompanhamentoForm.vue?vue&type=script&lang=js&"
import style0 from "./AcompanhamentoForm.vue?vue&type=style&index=0&id=3d2b06fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d2b06fc",
  null
  
)

export default component.exports